<div appKeyboardInset data-keyboard-cta-clearance
  class="tw-flex tw-h-full tw-flex-col tw-overflow-y-auto tw-overflow-x-hidden tw-scroll-pb-24 tw-bg-teal-200 tw-pb-keyboard-inset">
  <div class="tw-sticky tw-top-0 tw-z-0 tw-shrink-0">
    <div class="tw-mt-16 tw-h-6"></div>
    <div class="tw-relative tw-flex tw-w-full tw-items-end tw-justify-between tw-pt-11">
      <div class="tw-mb-8.5 tw-animate-onboarding_page_enter tw-pl-6 tw-font-lexend">
        <ng-content select="[shellEyebrow]"></ng-content>
        <ng-content select="[shellHeading]"></ng-content>
      </div>
      <div class="tw-relative tw-w-5/12 tw-shrink-0">
        <img class="tw-absolute -tw-bottom-10 -tw-right-3.5 tw-w-full"
          src="/assets/images/dr-charu.png"
          alt="Dr Charu" />
      </div>
    </div>
  </div>
<!--  white background section -->
  <div class="tw-z-10 tw-flex tw-flex-1 tw-flex-col tw-rounded-t-5 tw-bg-white tw-px-6 tw-pt-6">
    <div class="tw-animate-onboarding_page_enter tw-min-h-12 tw-shrink-0">
      <ng-content></ng-content>
    </div>
    @if (showFooter()) {
      <footer class="tw-mt-auto tw-shrink-0 tw-pb-safe-area-footer tw-pt-3"
        data-keyboard-cta>
        <ng-content select="[shellFooter]"></ng-content>
      </footer>
    }
  </div>
</div>
